import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseStrategyFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_STRATEGY_INTRODUCTION_ID = 'gh-strategy-introduction';

const GreenhouseStrategyIntroduction = () => {
  const { control, getValues } = useGreenhouseForm();

  const { introduction } =
    getValues('greenhouseStrategy') ?? ({} as IGreenhouseStrategyFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const ghGoalTermIntroductionEl = document.getElementById(
    GH_STRATEGY_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'greenhouseStrategy',
      control,
    }) ?? ({} as IGreenhouseStrategyFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        ghGoalTermIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="การกำหนดกลยุทธ์และแผนการจัดการก๊าซเรือนกระจกให้เป็นไปตามเป้าหมาย"
              setOpen={open}
              fieldPath="greenhouseStrategy.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalTermIntroductionEl
        )}
    </>
  );
};

export default GreenhouseStrategyIntroduction;
